<template>
    <div class="content-table">
        <el-table :data="tableData" style="width: 100%" stripe empty-text=" ">
            <el-table-column prop="operationTime" :label="$t('log.date')">
                <template slot-scope="scope">
                    {{ $moment(scope.row.operationTime).format("DD/MM/YYYY") }}
                </template>
            </el-table-column>
            <el-table-column prop="operationTime" :label="$t('log.time')">

                <template slot-scope="scope">
                    {{ $moment(scope.row.operationTime).format("HH:mm:ss") }}
                </template>
            </el-table-column>
            <el-table-column prop="accountName" :label="$t('log.account')">
            </el-table-column>
            <el-table-column prop="actionType" :label="$t('log.type')">
            </el-table-column>
            <el-table-column prop="description" :label="$t('log.content')">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array, default: () => ([])
        },
    },
}
</script>